import React, { useEffect, useState } from "react";
import { Share, Smartphone, X } from "lucide-react";

const DISMISS_KEY = "wl-install-dismissed";
const isIos = () => /iphone|ipad|ipod/i.test(navigator.userAgent);
const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

export const InstallPrompt = () => {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);
  const [ios, setIos] = useState(false);

  useEffect(() => {
    if (isStandalone()) return undefined;
    const dismissed = localStorage.getItem(DISMISS_KEY);
    if (dismissed && Date.now() - Number(dismissed) < 14 * 86400000) return undefined;
    if (!window.matchMedia("(max-width: 768px)").matches) return undefined;
    if (isIos()) {
      setIos(true);
      setShow(true);
      return undefined;
    }
    const handler = (e) => {
      e.preventDefault();
      setDeferred(e);
      setShow(true);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  if (!show) return null;

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, String(Date.now()));
    setShow(false);
  };
  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice;
    dismiss();
  };

  return (
    <div className="fixed bottom-3 left-3 right-3 z-50 md:hidden" data-testid="install-banner">
      <div className="bg-surface border border-border rounded-xl shadow-lg p-3.5 flex items-start gap-3">
        <div className="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0"
             style={{ background: "#16161A" }}>
          <Smartphone size={17} style={{ color: "#F4F430" }} />
        </div>
        <div className="min-w-0 flex-1">
          <div className="text-sm font-medium text-text-primary">Installa Wattline sul telefono</div>
          {ios ? (
            <div className="text-xs text-text-muted mt-0.5" data-testid="install-ios-hint">
              Tocca <Share size={11} className="inline -mt-0.5" /> <strong>Condividi</strong> in
              Safari e scegli <strong>"Aggiungi alla schermata Home"</strong>.
            </div>
          ) : (
            <>
              <div className="text-xs text-text-muted mt-0.5">
                Accesso rapido, a schermo intero, come un'app.
              </div>
              <button type="button" onClick={install} data-testid="install-btn"
                      className="wl-btn wl-btn--primary wl-btn--sm mt-2">
                Installa
              </button>
            </>
          )}
        </div>
        <button type="button" onClick={dismiss} aria-label="Chiudi" data-testid="install-dismiss"
                className="text-text-muted hover:text-text-primary flex-shrink-0">
          <X size={15} />
        </button>
      </div>
    </div>
  );
};
